module.exports = __webpack_public_path__ + "img/MLOGO_red_4rgb.9e46349f.svg";